import './signup.fa';

var ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
}

ready(() => {
    document.querySelectorAll('form input, form select, form textarea').forEach(el => {
        el.addEventListener('change', function (e) {
            e.target.classList.remove('is-valid', 'is-invalid');
        });
    });
});
